<template>
    <div>
        <a href="#" @click.prevent.stop="previewModel()" :class="$spa.css.contextmenu.link">
            <i :class="`${$spa.css.contextmenu.icon} far fa-eye`" />
            {{ $t('actions.see') }}
        </a>
        <a class="relative" href="#" @click.stop.prevent="createProfitabilityDocument" v-if="$store.state.worksite && model.ends_at && ! model.hasProfitabilityDocument()" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="creatingProfitabilityDocument"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-chart-line`" />
            {{ $t('timetracking.actions.add_to_worksite_profitability') }}
        </a>
        <a href="#" @click.prevent.stop="editModel()" :class="$spa.css.contextmenu.link" v-if="model.status == 'completed'">
            <i :class="`${$spa.css.contextmenu.icon} far fa-pencil`" />
            {{ $t('actions.edit') }}
        </a>
        <a class="relative" href="#" @click.stop.prevent="duplicateModel" v-if="model.status == 'completed'" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="duplicating"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-clone`" />
            {{ $t('timetracking.actions.duplicate') }}
        </a>
        <a class="relative" href="#" @click.stop.prevent="pauseModel" v-if="model.status == 'in_progress'" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="pausing"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-pause-circle`" />
            {{ $t('timetracking.actions.pause') }}
        </a>
        <a class="relative" href="#" @click.stop.prevent="restartModel" v-if="model.status == 'paused'" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="restarting"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-play-circle`" />
            {{ $t('timetracking.actions.restart') }}
        </a>
        <a class="relative" href="#" @click.stop.prevent="stopModel" v-if="model.status == 'in_progress' || model.status == 'paused'" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="stopping"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-stop`" />
            {{ $t('timetracking.actions.stop') }}
        </a>
        <a class="relative" href="#" @click.prevent.stop="deleteModel()" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="deleting"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-trash`" />
            {{ $t('actions.delete') }}
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                deleting: false,
                stopping: false,
                duplicating: false,
                pausing: false,
                restarting: false,
                creatingProfitabilityDocument: false,
            }
        },
        
        methods: {
            close()
            {
                this.$emit('close');
            },

            openModel()
            {
                this.model.open();
                this.close();
            },

            previewModel()
            {
                this.model.preview();
                this.close();
            },
            
            editModel()
            {
                this.model.edit();
                this.close();
            },

            async deleteModel()
            {
                this.deleting = true;

                await window.Planning.endpoints.timeActivity
                    .delete(this.model.uuid);

                this.close();
            },

            async duplicateModel()
            {
                this.duplicating = true;
                await window.Planning.endpoints.timeActivity.duplicate(this.model.uuid);
                this.close();
                this.duplicating = false;
            },

            async pauseModel()
            {
                this.pausing = true;
                this.model.ends_at = window.moment().format('YYYY-MM-DD HH:mm:ss');

                await window.Planning.endpoints.timeActivity.startPause(this.model.uuid);
                this.close();
                this.pausing = false;
            },

            async restartModel()
            {
                this.restarting = true;
                this.model.ends_at = window.moment().format('YYYY-MM-DD HH:mm:ss');

                await window.Planning.endpoints.timeActivity.stopPause(this.model.uuid);
                this.close();
                this.restarting = false;
            },

            async stopModel()
            {
                this.stopping = true;
                this.model.ends_at = window.moment().format('YYYY-MM-DD HH:mm:ss');

                await window.Planning.endpoints.timeActivity.update({uuid: this.model.uuid, data: this.model.requestData()})
                this.close();
                this.stopping = false;
            },

            async createProfitabilityDocument()
            {
                if ( ! this.model.worksite ) {
                    return;
                }

                this.creatingProfitabilityDocument = true;
                
                await window.Worksite.endpoints.worksiteProfitabilityDocument
                    .setWorksite(this.model.worksite)
                    .store({
                        type: 'labor',
                        status: 'sent',
                        number: `${this.model.title} (${this.$moment(this.model.starts_at).format('DD MMMM YYYY')} ${this.$moment(this.model.starts_at).format('HH[h]mm')} - ${this.$moment(document.ends_at).format('HH[h]mm')})`,
                        external_uuid: this.model.uuid,  
                        external_account_uuid: this.$spa.TrustUpPro.getAccountUuid('timetracker'),
                        external_source: 'timetracker',
                        amount: this.model.total.cost,
                        sent_at: window.moment(this.model.created_at).format('YYYY-MM-DD'),      
                        worksite_id: this.model.worksite.id
                    });
                
                this.close();
                this.creatingProfitabilityDocument = false;
            },
        }
    }
</script>
